import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import * as L from 'leaflet';
import { MapMarker } from './map.model';

delete (L.Icon.Default.prototype as any)._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'assets/leaflet/marker-icon-2x.png',
  iconUrl: 'assets/leaflet/marker-icon.png',
  shadowUrl: 'assets/leaflet/marker-shadow.png',
});

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class MapComponent implements OnChanges {

  @Input() zoom = 14;
  @Input() startPosition: [number,number] =[40.4168, -3.7038]
  @Input() markers: MapMarker[] = [];

  options!: L.MapOptions;
  layers: L.Layer[] = [];

  private map!: L.Map;

  ngOnInit(): void {
    this.initMap();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['markers']) {
      this.renderMarkers();
    }
  }

  onMapReady(map: L.Map): void {
    this.map = map;
  }

  private initMap(): void {
    this.options = {
      zoom: this.zoom,
      center: this.startPosition,
      layers: [
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '© OpenStreetMap contributors'
        })
      ]
    };
  }

  private renderMarkers(): void {
    this.layers = this.markers.map(m =>
      L.marker([m.lat, m.lng]).bindPopup(m.label || '')
    );
  }

  focusMarker(marker: MapMarker): void {
    if (!this.map) return;

    this.map.setView(
      [marker.lat, marker.lng],
      this.zoom,
      { animate: true }
    );
  }

  invalidateSize(): void {
    if (this.map) {
      this.map.invalidateSize();
    }
  }
}